// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-c6888ef6],.fade-leave-active[data-v-c6888ef6]{transition:opacity .5s}.fade-enter[data-v-c6888ef6],.fade-leave-to[data-v-c6888ef6]{opacity:0}", ""]);
// Exports
module.exports = exports;
